import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  Banknote,
  BarChart3,
  CheckCircle2,
  MapPin,
  ShieldCheck,
  TrendingUp,
  Users,
} from "lucide-react";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Business Analysis Report", 40, yPos);
    yPos += 40;

    // Business Identity & Profile
    doc.setFontSize(14);
    doc.text("Business Identity & Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Legal/Trade Name: ${data.businessDetails?.businessName || data.businessProfile?.name || data.businessName || 'N/A'}`, 40, yPos);
    doc.text(`Type of Entity: ${data.businessDetails?.businessType || data.businessProfile?.type || data.entityType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Business Sector: ${data.businessDetails?.industry || data.businessProfile?.sector || data.industry || 'N/A'}`, 40, yPos);
    doc.text(`Nature of Products: ${data.businessDetails?.products || data.businessProfile?.products || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`GST Status: ${data.businessDetails?.gstStatus || data.registrations?.gstStatus || 'N/A'}`, 40, yPos);
    doc.text(`Established On: ${data.businessDetails?.establishedDate || data.businessProfile?.establishedOn || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Business Age: ${data.businessDetails?.businessAge || data.businessProfile?.age || 'N/A'}`, 40, yPos);
    doc.text(`Contact: ${data.businessDetails?.contact || data.contactDetails?.phone || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Business Location & Infrastructure
    doc.setFontSize(14);
    doc.text("Business Location & Infrastructure", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Address: ${data.locationDetails?.address || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Rental Tenure: ${data.locationDetails?.rentalTenure || 'N/A'}`, 40, yPos);
    doc.text(`Location Type: ${data.locationDetails?.locationType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Asset Value: Rs ${data.locationDetails?.assetValue || 'N/A'}`, 40, yPos);
    doc.text(`Premises: ${data.locationDetails?.premises || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Rent: Rs ${data.locationDetails?.rent || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Sales & Income Pattern
    doc.setFontSize(14);
    doc.text("Sales & Income Pattern", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Mode of Sales: ${data.operationalDetails?.modeOfSale || 'N/A'}`, 40, yPos);
    doc.text(`Sales Cycle: ${data.operationalDetails?.salesCycle || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Monthly Peak Revenue: Rs ${data.financialProfile?.monthlyTurnover || 'N/A'}`, 40, yPos);
    doc.text(`Peak Period: ${data.operationalDetails?.peakPeriod || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`6-month Avg: Rs ${data.financialProfile?.avgMonthlyTurnover || 'N/A'}`, 40, yPos);
    doc.text(`Growth Trend: ${data.operationalDetails?.growthTrend || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Customers & Payments
    doc.setFontSize(14);
    doc.text("Customers & Payments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Customer Base: ${data.customerDetails?.customerBase || 'N/A'}`, 40, yPos);
    doc.text(`Collection Mode: ${data.customerDetails?.collectionMode || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Outstanding Receivables: Rs ${data.customerDetails?.outstandingReceivables || 'N/A'}`, 40, yPos);
    doc.text(`Payment Cycle: ${data.customerDetails?.paymentCycle || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Credit Given: ${data.customerDetails?.creditGiven || 'N/A'}`, 40, yPos);
    doc.text(`Invoice System: ${data.customerDetails?.invoiceSystem || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Business Banking Behavior
    doc.setFontSize(14);
    doc.text("Business Banking Behavior", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Account Type: ${data.bankingBehavior?.accountType || 'N/A'}`, 40, yPos);
    doc.text(`Bank: ${data.bankingBehavior?.bankName || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Monthly Credits: Rs ${data.bankingBehavior?.monthlyCredits || 'N/A'}`, 40, yPos);
    doc.text(`Avg Balance: Rs ${data.bankingBehavior?.avgBalance || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Txn Frequency: ${data.bankingBehavior?.txnFrequency || 'N/A'}`, 40, yPos);
    doc.text(`Bounce History: ${data.bankingBehavior?.bounceHistory || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Asset & Investment Summary
    doc.setFontSize(14);
    doc.text("Asset & Investment Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Machinery: ${data.assetSummary?.machinery || 'N/A'}`, 40, yPos);
    doc.text(`Vehicles: ${data.assetSummary?.vehicles || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Inventory: ${data.assetSummary?.inventory || 'N/A'}`, 40, yPos);
    doc.text(`Furniture: ${data.assetSummary?.furniture || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Digital Infra: ${data.assetSummary?.digitalInfra || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Licenses & Registrations
    doc.setFontSize(14);
    doc.text("Licenses & Registrations", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`GST Certificate: ${data.licensesRegistrations?.gstCertificate || 'N/A'}`, 40, yPos);
    doc.text(`Udyam (MSME): ${data.licensesRegistrations?.udyamMsme || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`FSSAI License: ${data.licensesRegistrations?.fssaiLicense || 'N/A'}`, 40, yPos);
    doc.text(`Shop & Establishment: ${data.licensesRegistrations?.shopEstablishment || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Municipal Permit: ${data.licensesRegistrations?.municipalPermit || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Business Health Scorecard
    doc.setFontSize(14);
    doc.text("Business Health Scorecard", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Revenue Consistency: ${data.businessScorecard?.revenueConsistency || 'N/A'}`, 40, yPos);
    doc.text(`Location Ownership: ${data.businessScorecard?.locationOwnership || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Asset Strength: ${data.businessScorecard?.assetStrength || 'N/A'}`, 40, yPos);
    doc.text(`Banking Pattern: ${data.businessScorecard?.bankingPattern || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Seasonality: ${data.businessScorecard?.seasonality || 'N/A'}`, 40, yPos);
    doc.text(`Business Tenure: ${data.businessScorecard?.businessTenure || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Analyst Comments & Recommendation
    doc.setFontSize(14);
    doc.text("Final Analyst Comments & Recommendation", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Business Viability: ${data.finalAnalyst?.businessViability || 'N/A'}`, 40, yPos);
    doc.text(`Suggested Sanction: ${data.finalAnalyst?.suggestedSanction || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Business analysis completed based on available operational data.",
      "Financial profile and asset assessment reviewed.",
      "Banking behavior and compliance status evaluated.",
      "Recommendation based on overall business health assessment."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("business-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const BusinessAnalysisReport = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-4 sm:p-6 text-sm space-y-6 min-h-screen max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <h2 className="text-white">Universal Business Analayser</h2>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
       
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Business Identity */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💼 Business Identity & Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Legal/Trade Name</strong>
            <span className="text-white">
              {getValue("businessDetails.businessName") ||
                getValue("businessProfile.name") ||
                getValue("businessName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Type of Entity</strong>
            <span className="text-white">
              {getValue("businessDetails.businessType") ||
                getValue("businessProfile.type") ||
                getValue("entityType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Business Sector</strong>
            <span className="text-white">
              {getValue("businessDetails.industry") ||
                getValue("businessProfile.sector") ||
                getValue("industry")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Nature of Products</strong>
            <span className="text-white">
              {getValue("businessDetails.products") ||
                getValue("businessProfile.products")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">GST Status</strong>
            <span className="text-white">
              {getValue("businessDetails.gstStatus") ||
                getValue("registrations.gstStatus")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Established On</strong>
            <span className="text-white">
              {getValue("businessDetails.establishedDate") ||
                getValue("businessProfile.establishedOn")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Business Age</strong>
            <span className="text-white">
              {getValue("businessDetails.businessAge") ||
                getValue("businessProfile.age")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Contact</strong>
            <span className="text-white">
              {getValue("businessDetails.contact") ||
                getValue("contactDetails.phone")}
            </span>
          </div>
        </div>
      </div>

      {/* Location */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <MapPin size={18} /> Business Location & Infrastructure
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex flex-col">
              <strong className="text-[#AAAAAA]">Address</strong>
              <span className="text-white">
                {data.locationDetails?.address || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Rental Tenure</strong>
              <span className="text-white">
                {data.locationDetails?.rentalTenure || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Location Type</strong>
              <span className="text-white">
                {data.locationDetails?.locationType || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Asset Value</strong>
              <span className="text-white">
                ₹{data.locationDetails?.assetValue?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Premises</strong>
              <span className="text-white">
                {data.locationDetails?.premises || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Rent</strong>
              <span className="text-white">
                ₹{data.locationDetails?.rent?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Sales & Income */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BarChart3 size={18} /> Sales & Income Pattern
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Mode of Sales</strong>
              <span className="text-white">
                {data.operationalDetails?.modeOfSale || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Monthly Peak Revenue</strong>
              <span className="text-white">
                ₹
                {data.financialProfile?.monthlyTurnover?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">6-month Avg</strong>
              <span className="text-white">
                ₹
                {data.financialProfile?.avgMonthlyTurnover?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Sales Cycle</strong>
              <span className="text-white">
                {data.operationalDetails?.salesCycle || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Peak Period</strong>
              <span className="text-white">
                {data.operationalDetails?.peakPeriod || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Growth Trend</strong>
              <span className="text-green-400">
                {data.operationalDetails?.growthTrend || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Customers & Payments */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Users size={18} /> Customers & Payments
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Customer Base</strong>
              <span className="text-white">
                {data.customerDetails?.customerBase || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Outstanding Receivables
              </strong>
              <span className="text-white">
                ₹
                {data.customerDetails?.outstandingReceivables?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Credit Given</strong>
              <span className="text-white">
                {data.customerDetails?.creditGiven || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Collection Mode</strong>
              <span className="text-white">
                {data.customerDetails?.collectionMode || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Payment Cycle</strong>
              <span className="text-white">
                {data.customerDetails?.paymentCycle || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Invoice System</strong>
              <span className="text-white">
                {data.customerDetails?.invoiceSystem || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Banking Behaviour */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Banknote size={18} /> Business Banking Behavior
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Account Type</strong>
              <span className="text-white">
                {data.bankingBehavior?.accountType || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Bank</strong>
              <span className="text-white">
                {data.bankingBehavior?.bankName || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Monthly Credits</strong>
              <span className="text-white">
                ₹
                {data.bankingBehavior?.monthlyCredits?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Avg Balance</strong>
              <span className="text-white">
                ₹{data.bankingBehavior?.avgBalance?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Txn Frequency</strong>
              <span className="text-white">
                {data.bankingBehavior?.txnFrequency || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Bounce History</strong>
              <span className="text-white">
                {data.bankingBehavior?.bounceHistory || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Assets & Investments */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <TrendingUp size={18} /> Asset & Investment Summary
        </div>
        <div className="space-y-3 mt-2">
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Machinery</strong>
            <span className="text-white">
              {data.assetSummary?.machinery || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Vehicles</strong>
            <span className="text-white">
              {data.assetSummary?.vehicles || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Inventory</strong>
            <span className="text-white">
              {data.assetSummary?.inventory || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Furniture</strong>
            <span className="text-white">
              {data.assetSummary?.furniture || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Digital Infra</strong>
            <span className="text-white">
              {data.assetSummary?.digitalInfra || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Licenses */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ShieldCheck size={18} /> Licenses & Registrations
        </div>
        <div className="space-y-3 mt-2">
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">GST Certificate</strong>
            <span
              className={
                data.licensesRegistrations?.gstCertificate === "Verified"
                  ? "text-green-400"
                  : "text-red-500"
              }
            >
              {data.licensesRegistrations?.gstCertificate || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Udyam (MSME)</strong>
            <span
              className={
                data.licensesRegistrations?.udyamMsme === "Verified"
                  ? "text-green-400"
                  : "text-red-500"
              }
            >
              {data.licensesRegistrations?.udyamMsme || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">FSSAI License</strong>
            <span
              className={
                data.licensesRegistrations?.fssaiLicense === "Verified"
                  ? "text-green-400"
                  : "text-red-500"
              }
            >
              {data.licensesRegistrations?.fssaiLicense || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Shop & Establishment</strong>
            <span
              className={
                data.licensesRegistrations?.shopEstablishment === "Verified"
                  ? "text-green-400"
                  : "text-red-500"
              }
            >
              {data.licensesRegistrations?.shopEstablishment || "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <strong className="text-[#AAAAAA]">Municipal Permit</strong>
            <span
              className={
                data.licensesRegistrations?.municipalPermit === "Verified"
                  ? "text-green-400"
                  : "text-red-500"
              }
            >
              {data.licensesRegistrations?.municipalPermit || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Business Scorecard */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <TrendingUp size={18} /> Business Health Scorecard
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Revenue Consistency</strong>
            <br />
            <span className="text-white text-lg">
              {data.businessScorecard?.revenueConsistency || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Location Ownership</strong>
            <br />
            <span className="text-yellow-300 text-lg">
              {data.businessScorecard?.locationOwnership || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Asset Strength</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.businessScorecard?.assetStrength || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Banking Pattern</strong>
            <br />
            <span className="text-white text-lg">
              {data.businessScorecard?.bankingPattern || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Seasonality</strong>
            <br />
            <span className="text-white text-lg">
              {data.businessScorecard?.seasonality || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Business Tenure</strong>
            <br />
            <span className="text-white text-lg">
              {data.businessScorecard?.businessTenure || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CheckCircle2 size={18} /> Final Analyst Comments & Recommendation
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Business Viability</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalAnalyst?.businessViability || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Suggested Sanction</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalAnalyst?.suggestedSanction || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Summary */}
      <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
        <h3 className="font-semibold text-green-500 mb-2">📝 Final Comments</h3>
        <ul className="list-disc pl-5 space-y-1">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              Business analysis completed based on available operational data.
            </li>,
            <li key="default2">
              Financial profile and asset assessment reviewed.
            </li>,
            <li key="default3">
              Banking behavior and compliance status evaluated.
            </li>,
            <li key="default4">
              Recommendation based on overall business health assessment.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default BusinessAnalysisReport;
